<template>
  <div :hidden="!domainID" style="padding-bottom:20px;">
    <div style="padding-bottom:2px;cursor:pointer" @click="triggerHide">
      <label style="padding-right:10px;padding-bottom:5px;display:inline">{{ $t('orderLine.prices') }}</label>
      <svg-icon :hidden="!hide" :size="1.5" icon-class="arrow-right" />
      <svg-icon :hidden="hide" :size="1.5" icon-class="arrow-down" />
    </div>
    <div :hidden="hide">
      <el-table ref="priceTable" :data="prices" border row-key="id" fit>
        <el-table-column :label="$t('common.description')" prop="code" width="200px">
          <template slot-scope="scope">
            <Select
              v-model="scope.row['priceListItemID']"
              :placeholder="$t('common.description')"
              clearable
              :options="priceListItems"
              value-field="id"
              label-field="description"
              class="search-select"
              @input="handlePriceChange(scope.row, $event)"
            />
          </template>
        </el-table-column>
        <el-table-column :label="$t('orderLine.amount')" prop="name" width="115px">
          <template slot-scope="scope">
            <MDinput
              v-model="scope.row['quantity']"
              type="number"
              :precision="2"
              style="width:50%;display:inline-block"
              @input="changeTotalPrice(scope.row)"
            />
            {{ scope.row['unit'] }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.price')" prop="code">
          <template slot-scope="scope">
            <span>{{ scope.row.matrixYN ? 'n.t.b.' : scope.row['laborSymbol'] + scope.row['price'] || '' }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('orderLine.discount')" prop="name">
          <template slot-scope="scope">
            <MDinput
              v-model="scope.row['discountPercentage']"
              type="number"
              style="width:80%;"
              suffix="%"
              :precision="0"
              @input="changeTotalPrice(scope.row)"
            />
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.total')" prop="code">
          <template slot-scope="scope">
            <span>{{
              scope.row.matrixYN
                ? 'n.t.b.'
                : (scope.row['laborSymbol'] || '') +
                  (scope.row['totalPrice'] !== null && scope.row['totalPrice'] !== undefined
                    ? scope.row['totalPrice']
                    : '')
            }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import SvgIcon from '@/components/SvgIcon';
import Select from '@/components/DSE/Select';
import MDinput from '@/components/MDinput';

export default {
  name: 'StoreTable',
  components: {
    SvgIcon,
    Select,
    MDinput
  },
  props: {
    domainID: {
      type: Number
    }
  },
  data() {
    return {
      loading: true,
      errorMsg: '',
      prices: [{ quantity: 1, discountPercentage: 0 }],
      hide: false
    };
  },
  computed: {
    priceListItems() {
      return this.$store.getters['priceListItem/loadedItems'].filter(lpli => lpli.domainID === this.domainID);
    }
  },
  watch: {
    domainID() {
      this.$store.dispatch('priceListItem/getItems', { query: { domainid: this.domainID } });
    }
  },
  created() {
    this.loading = false;
  },
  methods: {
    emitValues() {
      const priceDto = this.prices
        .filter(p => p.priceListItemID)
        .map(p => ({
          priceListItemID: p.priceListItemID,
          quantity: p.quantity,
          discountPercentage: p.discountPercentage
        }));
      this.$emit('input', { prices: priceDto });
    },
    triggerHide() {
      this.hide = !this.hide;
    },
    handlePriceChange(row, priceListItemID) {
      if (priceListItemID) {
        const selectedPriceListItem = this.priceListItems.find(pli => pli.id === priceListItemID);
        row.unit = this.formatUnitOption(selectedPriceListItem['unitOption']);
        row.price = selectedPriceListItem.laborPrice;
        row.laborSymbol = selectedPriceListItem.laborSymbol;
        row.matrixYN = selectedPriceListItem.matrixYN;
        if (this.prices.every(r => r.priceListItemID)) {
          this.prices.push({ quantity: 0, discountPercentage: 0 });
        }
      } else {
        row.unit = '';
        row.price = '';
        row.laborSymbol = '';
        row.matrixYN = false;
      }
      this.changeTotalPrice(row);
      this.emitValues();
    },
    changeTotalPrice(row) {
      let totalPrice = row.quantity * row.price;
      if (row.discountPercentage) {
        totalPrice = Math.round((totalPrice - totalPrice * row.discountPercentage * 0.01) * 100) / 100;
      }
      row.totalPrice = totalPrice ? totalPrice.toFixed(2) : 0;
      this.emitValues();
    },
    formatUnitOption(unitOption) {
      const option = this.$store.getters['option/loadedOptions']('capacityUnit').find(item => item.code === unitOption);
      return option && option.description;
    }
  }
};
</script>
